export enum RoleTarget{
  Entities = 1,
  Locations = 2
}
